//
//
//
//
//
//
//
//
//
//
//

import baseInfo from './components/baseInfo';
import ranking from './components/ranking';
import gridMenu from './components/gridMenu';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { mediadomainApi } from '@/api/systemSetting';
export default {
  name: 'Dashboard',
  components: {
    baseInfo: baseInfo,
    gridMenu: gridMenu,
    ranking: ranking
  },
  mounted: function mounted() {
    this.getMediadomain();
  },
  methods: {
    checkPermi: checkPermi,
    //图片域名
    getMediadomain: function getMediadomain() {
      var _this = this;
      mediadomainApi().then(function (res) {
        localStorage.setItem('mediaDomain', res);
        _this.$store.commit('settings/SET_mediaDomain', res);
      });
    }
  }
};